import React from "react";
import ContactPage from "@/components/contact-page";
import Footer from "@/components/Footer";

const Contact = (props) => {
    return (
        <main>
            <ContactPage/>
            <Footer/>
        </main>
    );
};

export default Contact;
